export default __webpack_public_path__ + "static/media/dots-white.88953158.svg";